const URLPlots = '/bda/v0/constructPlot';
const URLComparison = '/bda/v0/compareReports';
import axios from 'axios';
import store from '@/store';
import {
  ConfigName,
  newConfiguration,
} from '@/common/plotDefinitions.js';

const zoneNotify = 'AppGeneralUser';

const GeneratePlot = {
  ResponseBackEnd: function ResponseBackEnd(
    success = false,
    lastError = '',
    warnings = [],
    dataGraph = [],
  ) {
    this.success = success;
    this.dataGraph = dataGraph;
    this.lastError = lastError;
    this.warnings = warnings;
  },
  async getPlotThirdParty(parent, route, data) {
    try {
			const headers = {
        'Content-Type': 'application/json',
      };

      headers.Authorization = `Bearer ${store.getters.getTokenMiddlewareAuth}`
      const response = await axios.post(route, data,{headers});

      return response.data;
    } catch (error) {
      const errTitle = 'Service no available';
      const errText =
        'Not possible to process your files. Please contact the administrator';
      parent.$notifTerm.addNotification(
        parent.$notifTerm.typesNotif.ERROR,
        errTitle,
        errText,
        zoneNotify,
      );
      return new this.ResponseBackEnd(
        false,
        `Not possible to process your files. Please contact the administrator: ${error}`,
      );
    }
  },
  async getDataFromSource(parent, route) {
    try {
      const req = await fetch(route, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT',
        },
      });
      const response = await req.json();

      return response;
    } catch (error) {
      const errTitle = 'Third party not available';
      const errText = 'Not possible to extract the data from the source';
      parent.$notifTerm.addNotification(
        parent.$notifTerm.typesNotif.ERROR,
        errTitle,
        errText,
        zoneNotify,
      );
      return new this.ResponseBackEnd(
        false,
        `Not possible to retrieve the data from the third party. Please contact the third party provider: ${error}`,
      );
    }
  },
  async getPlot(parent, data, configuration, generalConfig, mainName, url_req = URLPlots, extraPayload={}) {
    try {
      const dataRequest = {
        data,
        configuration: newConfiguration.mapBackendPayloadfromConfig(configuration, generalConfig, mainName),
      };

      const headers = {
        'Content-Type': 'application/json',
      };
      if(url_req === URLPlots)
        headers.Authorization = `Bearer ${store.getters.getTokenMiddlewareAuth}`
      const response = await axios.post(url_req, { ...dataRequest, ...extraPayload}, { headers });
      return response.data;
    } catch (error) {
      const errTitle = 'Service no available';
      const errText =
        'Not possible to process your files. Please contact the administrator';
      parent.$notifTerm.addNotification(
        parent.$notifTerm.typesNotif.ERROR,
        errTitle,
        errText,
        zoneNotify,
      );
      return new this.ResponseBackEnd(
        false,
        `Not possible to process your files. Please contact the administrator: ${error}`,
      );
    }
  },
  async getPlotFromPayload(parent, dataRequest) {
    try {

      const headers = {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${store.getters.getTokenMiddlewareAuth}`,
      };
      const response = await axios.post(URLPlots, dataRequest, { headers });
      return response.data;
    } catch (error) {
      const errTitle = 'Service no available';
      const errText =
        'Not possible to process the payload. Please contact the administrator';
      parent.$notifTerm.addNotification(
        parent.$notifTerm.typesNotif.ERROR,
        errTitle,
        errText,
        zoneNotify,
      );
      return new this.ResponseBackEnd(
        false,
        `Not possible to process your files. Please contact the administrator: ${error}`,
      );
    }
  },
  async getComparison(parent, data) {
    try {
      const dataRequest = { data };
      const headers = {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${store.getters.getTokenMiddlewareAuth}`,
      };
      const response = await axios.post(URLComparison, dataRequest, { headers });
      return response.data;
    } catch (error) {
      parent.$notify({
        group: 'AppGeneralUser',
        title: 'Service no available',
        type: 'error',
        text: 'Not possible to compare the reports. Please contact the administrator',
      });
      store.dispatch('addMessageTerminalSection',{
        type: 'ERROR',
        text: 'Generate Plots. Not possible to compare the reports. Please contact the administrator',
      });
      const response = new this.ResponseBackEnd(
        false,
        `Not possible to process your files. Please contact the administrator: ${error}`,
      );

      return response;
    }
  },
  async getPreprocPlot(
    parent,
    data,
    configuration,
    generalConfig,
    isCrono,
    xAxisTypeVal,
    yAxisTypeVal,
  ) {
    configuration = newConfiguration.mapNewConfiguration(configuration);
    const modifConfiguration = {
      PreProcessing: configuration.PreProcessing,
      [ConfigName.BasePropStudy]: {
        [ConfigName.xAxisType]: xAxisTypeVal,
        [ConfigName.yAxisType]: yAxisTypeVal,
      },
      [ConfigName.BaseAxisProperties]:
        configuration[ConfigName.BaseAxisProperties] || {},
    };
    return this.getPlot(
      parent,
      data,
      modifConfiguration,
      generalConfig,
      '',
    );
  },
  URLPlots
};

export default GeneratePlot;
